import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=60cd1c2c&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=js&"
export * from "./userInfo.vue?vue&type=script&lang=js&"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=60cd1c2c&lang=scss&scoped=true&"
import style1 from "./userInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cd1c2c",
  null
  
)

export default component.exports